/* Import TinyMCE */
import tinymce from 'laravel-core/tinymce';

/* Default icons are required. After that, import custom icons if applicable */
import 'laravel-core/tinymce/icons/default';

/* Required TinyMCE components */
import 'laravel-core/tinymce/themes/silver';
import 'laravel-core/tinymce/models/dom';

/* Import a skin (can be a custom skin instead of the default) */
import 'laravel-core/tinymce/skins/ui/oxide/skin.css';

/* Import plugins */
import 'laravel-core/tinymce/plugins/advlist';
import 'laravel-core/tinymce/plugins/code';
// import 'laravel-core/tinymce/plugins/emoticons'; //emoticons
// import 'laravel-core/tinymce/plugins/emoticons/js/emojis';
import 'laravel-core/tinymce/plugins/link';
import 'laravel-core/tinymce/plugins/lists';
import 'laravel-core/tinymce/plugins/table';
import 'laravel-core/tinymce/plugins/image';


import './langs/fr_FR';

// import contentAppCss from '/resources/scss/app.scss?inline';
// import contentCmsCss from '/resources/laravel-cms/scss/app.scss?inline';

let editorOptions = {
    selector: 'textarea.editor',
    plugins: 'advlist code link lists table',
    menubar: false,
    toolbar: 'undo redo | styles bold italic Underline Strikethrough | alignleft aligncenter alignright link |  bullist numlist | image | code',
    skin: false,
    content_css: false,
    promotion: false,
    language: 'fr_FR',
    // content_style: contentAppCss.toString() + '\n' +  contentCmsCss.toString(),
    content_style: '',
    content_css: '/build/css/app.css',
    /* Styles */
    preview_styles: 'font-size font-weight text-transform text-decoration',
    style_formats: [
        { title: 'Headings', items: [
            { title: 'Heading 2', format: 'h2' },
            { title: 'Heading 3', format: 'h3' },
            { title: 'Heading 4', format: 'h4' },
            { title: 'Heading 5', format: 'h5' },
            { title: 'Heading 6', format: 'h6' }
        ]},
        { title: 'Paragraph', format: 'p' },
        { title: 'Div', format: 'div' },
    ],
    body_class: 'p-4',
    file_picker_types: 'image',
    image_advtab: true
}

window.editorOptions = editorOptions